(function () {
  class PaneFinder extends google.maps.OverlayView {
    constructor(map) {
      super();
      this.map = map;
      this.setMap(map);
    }

    onAdd() {}
  }

  window.PaneFinder = PaneFinder;
})(window);
